import Styled from "styled-components";

export const CartItemsDropdownContainer = Styled.div`

width: 100%;
display: flex;
height: 80px;
margin-bottom: 15px;

img {
    width: 25%;
}
`;

export const ItemDetails = Styled.div`

width: 75%;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
padding: 10px 20px;

.name {

}
`;


export const ItemName = Styled.span`
font-size: 16px;
`;

